import React from "react";
import DataTable, {
  TableColumn,
  PaginationComponentProps,
} from "react-data-table-component";
import { paginationRowsPerPageOptions } from "../../utils/Constant";

interface ICustomDataTableProps<T> {
  columns: TableColumn<T>[];
  data: T[];
  dense?: boolean;
  pageNo?: number;
  striped?: boolean;
  loading?: boolean;
  pageSize?: number;
  totalRows?: number;
  className?: string;
  subHeader?: boolean;
  noHeader?: boolean;
  onRowClicked?: any;
  toggleCleared?: boolean;
  pointerOnHover?: boolean;
  selectableRows?: boolean;
  selectableRowDisabled?: (row: T) => boolean;
  expandableRows?: boolean;
  noDataComponent?: any;
  highlightOnHover?: boolean;
  paginationServer?: boolean;
  expandableRowExpanded?: any;
  expandOnRowClicked?: boolean;
  expandableRowsComponent?: any;
  onRowExpandToggled?: (expanded: boolean, row: T) => void;
  fixedHeaderScrollHeight?: string;
  loaderComponent?: React.ReactNode;
  subHeaderComponent?: React.ReactNode;
  conditionalRowStyles?: any;
  onPageChange?: (page: number) => void;
  onSelectRowsChange?: (state: any) => void;
  onRowsPerPageChange?: (newPerPage: number, page: number) => void;
  customStyles?: any;
  paginationComponent?: React.ComponentType<PaginationComponentProps>;
}

const CustomDataTable = <T,>({
  data,
  customStyles,
  paginationComponent,
  pageNo,
  columns,
  pageSize,
  totalRows,
  onPageChange,
  onRowClicked,
  dense = false,
  toggleCleared,
  expandableRows,
  loaderComponent,
  noDataComponent,
  striped = true,
  noHeader = true,
  loading = false,
  subHeader = false,
  subHeaderComponent,
  onSelectRowsChange,
  expandOnRowClicked,
  onRowsPerPageChange,
  onRowExpandToggled,
  expandableRowExpanded,
  expandableRowsComponent,
  pointerOnHover = false,
  selectableRows = false,
  selectableRowDisabled,
  highlightOnHover = true,
  paginationServer = false,
  conditionalRowStyles,
  fixedHeaderScrollHeight = "100vh",
  className = "display dataTable border custom-scrollbar f-12",
}: ICustomDataTableProps<T>) => {
  return (
    <DataTable
      customStyles={customStyles}
      pagination
      paginationComponent={paginationComponent}
      fixedHeader
      data={data}
      dense={dense}
      columns={columns}
      striped={striped}
      noHeader={noHeader}
      className={className}
      subHeader={subHeader}
      progressPending={loading}
      onRowClicked={onRowClicked}
      onChangePage={onPageChange}
      paginationPerPage={pageSize}
      paginationDefaultPage={pageNo}
      expandableRows={expandableRows}
      pointerOnHover={pointerOnHover}
      paginationTotalRows={totalRows}
      selectableRows={selectableRows}
      selectableRowDisabled={selectableRowDisabled}
      noDataComponent={noDataComponent}
      clearSelectedRows={toggleCleared}
      highlightOnHover={highlightOnHover}
      paginationServer={paginationServer}
      progressComponent={loaderComponent}
      expandOnRowClicked={expandOnRowClicked}
      subHeaderComponent={subHeaderComponent}
      onSelectedRowsChange={onSelectRowsChange}
      onChangeRowsPerPage={onRowsPerPageChange}
      onRowExpandToggled={onRowExpandToggled}
      expandableRowExpanded={expandableRowExpanded}
      fixedHeaderScrollHeight={fixedHeaderScrollHeight}
      expandableRowsComponent={expandableRowsComponent}
      conditionalRowStyles={conditionalRowStyles}
      paginationRowsPerPageOptions={paginationRowsPerPageOptions}
    />
  );
};

export default CustomDataTable;
